import { Block } from 'ui-kit/blocks'
import { Container, DefaultPageLayout } from 'routes/components/Layout'
import { LandingHero } from './components/Hero'
import { LandingCompanies } from './components/Companies'
import { LandingAI } from './components/AI'
import { LandingDifference } from './components/Difference'
import { LandingNetwork } from './components/Network'
import { LandingFramework } from './components/Framework'
import { LandingIDE } from './components/IDE'
import { LandingIntegrations } from './components/Integrations'
import { LandingUX } from './components/UX'
import { LandingDevelopment } from './components/Development'
import { LandingInfrastructure } from './components/Infrastructure'
import { LandingBestSupport } from './components/BestSupport'
import classes from './index.module.scss'

export default function IndexPage({
  totalIntegrations,
}: {
  totalIntegrations: number
}) {
  return (
    <DefaultPageLayout className={classes.page}>
      <Container grid>
        <LandingHero />
        <LandingCompanies />
        <LandingAI />
        <LandingDifference />
        <Block variant={'shadowMob'} className={classes.wrapper}>
          <LandingNetwork totalIntegrations={totalIntegrations} />
          <LandingIntegrations />
          <LandingIDE />
          <LandingFramework />
          <LandingUX />
          <LandingDevelopment />
          <LandingInfrastructure />
        </Block>
        <LandingBestSupport />
      </Container>
    </DefaultPageLayout>
  )
}
